export default __webpack_public_path__ + "static/lightningImages-322f78552129471223dcb91c225949e6.png";